<template>
  <div id="">
    <div class="introduce">
      <p>Please finish all required forms which are necessary for your exhibition.</p>
      <!-- <p style="color:red">"Required Objects" for Shell Scheme: “Company name” “Exhibitor Badges”</p>
      <p style="color:red">"Required Objects" for Raw Space: “Stand Contractor” “Electrical & Telecommunication Equipment” “Facilities Location” “Notice For Raw Space Insurance” “Exhibitor Badges”</p> -->
    </div>
    <div class="downPdf"><div class="pdfIcon"><img :src="pdfIcon" alt="" width="100%"></div><a class="iconDownText" :href="demoExcel1" style="font-size:14px;"  target="_blank">Exhibitor Manual Download(full verision)</a></div>

    <div class="tableWarp">
      <!-- {{userInfo.bthType}} -->
      <div class="tableTtiel">Required</div>
      <div class="tableContent">
        <el-table  border :data="btTable" style="width: 100%">
          <el-table-column
            prop="name"
            label="Form Name">
            <template slot-scope="scope">
              <span class="tableBtn" @click="showDetail(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="Deadline"
            width="180">
          </el-table-column>

        </el-table>
      </div>

      <div class="tableTtiel">Optional</div>
      <div class="tableContent">
        <el-table border :data="nbtTable" style="width: 100%">
          <el-table-column
            prop="name"
            label="Form Name">
            <template slot-scope="scope">
              <span class="tableBtn" @click="showDetail(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="Deadline"
            width="180">
          </el-table-column>

        </el-table>
      </div>

      <div class="bottomText">
        <p>Exhibitors must fill in and submit the required forms on time according to the categories in the <span>"Required Objects"</span> column and the corresponding deadlines to avoid delaying your participation.</p>
        <p>Except for the indications, the rest are optional forms. Exhibitors are requested to fill in as needed. If you have any questions about the content of the form, please consult the contact unit and contact person at the top of each form.</p>
      </div>
    </div>

    <el-dialog
      :title="currentData.name"
      :visible.sync="dialogVisible"
      width="50%"
     >
      <div class="dialogContent">
        <div style="font-weight:bold;font-size:14px">Please click to download<a class="dialogA" :href="currentData.url" style="font-size:14px;"  target="_blank">{{currentData.name}}</a></div>
        <div style="padding:20px 0 6px ;font-size:14px;">Please return form to:</div>
        <div class="dialogConct" v-html="currentData.tip"></div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

  </div>
</template>

<script>
import pdfIcon from '@/assets/pdfIcon.png'
import tzbtm from '@/assets/tzbtm.png'
export default {
  name: 'ServiceBooking',
  data: () => ({
    pdfIcon,
    tzbtm,
    demoExcel1:'./China International Fruit Expo 2021 EN.pdf',
    userInfo: JSON.parse(localStorage.getItem('userInfo')),
    btTable:[],   //必填
    nbtTable:[],  //不必填
    tzBtTableData:[  //特装必填
      {         
        date: 'July 20, 2024',
        name: 'Form 4A Stand Contractor-raw space Commission',
        url:'./tz/bt/Form 4A Stand Contractor-raw space Commission.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 4B-C Electrical & Telecommunication Equipment',
        url:'./tz/bt/Form 4B-C Electrical & Telecommunication Equipment.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 4D Facilities Location',
        url:'./tz/bt/Form 4D Facilities Location.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 7A Real-name Authentication Form for Erection Contractor and Transport Contractor',
        url:'./tz/bt/Form 7A Real-name Authentication Form for Erection Contractor and Transport Contractor.pdf',
        tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888 </p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net </p><p>Website: www.sniec.net</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 7B Letter of Authorization',
        url:'./tz/bt/Form 7B Letter of Authorization.pdf',
 tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888 </p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net </p><p>Website: www.sniec.net</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 7C Safety Commitment of the Transport Contractor',
        url:'./tz/bt/Form 7C Safety Commitment of the Transport Contractor.pdf',
 tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888 </p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net </p><p>Website: www.sniec.net</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 7D Safety Commitment of the Erection Contractor',
        url:'./tz/bt/Form 7D Safety Commitment of the Erection Contractor.pdf',
 tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888 </p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net </p><p>Website: www.sniec.net</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Notice For Raw Space Insurance',
        url:'./tz/bt/Notice For Raw Space Insurance.pdf',
        tip:'<div><p>Taiping Property Insurance Co., Ltd. Shanghai  </p><p>Branch</p><p>Exhibition Risk Management Manager </p><p>Contact : Mr. Li Xin / Ms. Chen WeiJun</p><p>Tel: (86) 21-51113250</p><p>18217731507、18217730796</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Overseas raw space move-in registration guide',
        url:'./tz/bt/Overseas raw space move-in registration guide.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd </p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {         
        date: 'July 15, 2024',
        name: 'Review of Raw Space construction drawings',
        url:'./tz/bt/Review of Raw Space construction drawings.pdf',
        tip:'<div><p>OptSafe Management Services (Shanghai) Limited</p><p>Contact : Mr.Hu Weizhen / Mr.Ge Weichao</p><p>Tel:21-69957319/7316</p><p>Email: CIFE@opt-safe.com</p></div>'
      },
      {         
        date: 'August 27, 2024',
        name: 'Temporary booth monitoring and one-button alarm visual intercom device',
        url:'./tz/bt/Temporary booth monitoring and one-button alarm visual intercom device.pdf',
        tip:'<div><p><img src="'+tzbtm+'" width="170px"></p><p style="padding-bottom:10px">WeChat open the picture, long press to identify the QR code in the picture to enter the exhibition</p><p>equipment rental applet</p><p>New International Expo Centre equipment order, pick up, return, invoice and other issues please </p><p>consult:</p><p>Customer service telephone: 15000663737 (WeChat same number) / 13062633245 / landline 021-5076-1829</p><p>Customer service working time during the exhibition 9:00-18:00, to carry out the period: 8:00-18:00</p></div>'
      }
    ],
    tzNbtTableData:[    //特装不必填
      {         
        date: 'July 20, 2024',
        name: 'Form 5 Exhibition Personnel Service (interpreter, hostess) ',
        url:'./tz/nbt/Form 5 Exhibition Personnel Service (interpreter, hostess) .pdf',
        tip:'<div><p>Wai Yuan Translation Service CO</p><p>Tel:(86)13818598778</p><p>E-mail: swfy@foxmail.com</p><p>Contact: Mr. Wang</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 6 Introduction of Official Hotels',
        url:'./tz/nbt/Form 6 Introduction of Official Hotels.pdf',
        tip:'<div><p>Mr. Seven Liu</p><p>Orient Event Service</p><p>WeChat ID: 17321367242</p><p>booking@orient-explorer.com.cn</p><p>Tel: +86 21 51099795</p><p>Make secured online reservation</p><p><a href="https://www.orient-explorer.net/CIFE/"  target="_blank">www.orient-explorer.net/CIFE</a></p><p style="padding-top:10px">LJZ Supreme Tower Hotel</p><p>Tel:(86)13818748050</p><p>+86 21 68986666-3301</p><p>E-mail: kimi.shen@ljzsupremetower.com</p><p>Contact: Kimi</p><p>Intention to Occupy LJZ Supreme Tower Hotel Form: </p><p><a href="https://wj.qq.com/s2/14786136/6loe/"  target="_blank">https://wj.qq.com/s2/14786136/6loe/</a></p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 8A Building Approval For Multi-Storey Stand Design',
        url:'./tz/nbt/Form 8A Building Approval For Multi-Storey Stand Design.pdf',
        tip:'<div><p>HAH Consulting & Exhibition Co.,Ltd.</p><p>Shanghai, E2-2E1, 2345 Long yang Road, Pudong New Area Shanghai 201204 P.R.C</p><p>Tel.: +86 (0)21 28906633/34/35</p><p>Fax: +86 (0)21 28906000/28906050</p><p>Contact Person: Ms.Kim Gu</p><p>Email:hah@hahchina.com</p></div>'
      },
      {         
        date: 'July 20, 2024',
        name: 'Form 8B Building Approval For One-Storey Stand Design',
        url:'./tz/nbt/Form 8B Building Approval For One-Storey Stand Design.pdf',
        tip:'<div><p>HAH Consulting & Exhibition Co.,Ltd.</p><p>Shanghai, E2-2E1, 2345 Long yang Road, Pudong New Area Shanghai 201204 P.R.C</p><p>Tel.: +86 (0)21 28906633/34/35</p><p>Fax: +86 (0)21 28906000/28906050</p><p>Contact Person: Ms.Kim Gu</p><p>Email:hah@hahchina.com</p></div>'
      }
    ],
    btBtTableData:[   //标摊必填
      {         
        date: 'July 20, 2024',
        name: 'Form3A Company Name for Stand Shell Scheme',
        url:'./bt/bt/Form3A Company Name for Stand Shell Scheme.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {         //标摊必填
        date: 'July 20, 2024',
        name: 'Form3B Company Name for Upgrade Shell Scheme & Deluxe Shell Scheme',
        url:'./bt/bt/Form3B Company Name for Upgrade Shell Scheme & Deluxe Shell Scheme.pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: 19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
    ],
    btNbtTableData:[   //标摊不必填
      {      
        date: 'July 20, 2024',
        name: 'Form 3C Additional Furniture Rental ( Standard Shell Scheme only )',
        url:'./bt/nbt/Form 3C Additional Furniture Rental ( Standard Shell Scheme only ).pdf',
        tip:'<div><p>Shanghai Chuangyu Exhibition Co., Ltd</p><p>Contact: Mr. Wang Daowei</p><p>Mob: (86)19921238017</p><p>E-mail: cyexpo@vip.163.com</p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 5 Exhibition Personnel Service (interpreter, hostess) ',
        url:'./bt/nbt/Form 5 Exhibition Personnel Service (interpreter, hostess) .pdf',
        tip:'<div><p>Wai Yuan Translation Service CO</p><p>Tel:(86)13818598778</p><p>E-mail: swfy@foxmail.com</p><p>Contact: Mr. Wang</p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 6 Introduction of Official Hotels',
        url:'./bt/nbt/Form 6 Introduction of Official Hotels.pdf',
        tip:'<div><p>Mr. Seven Liu</p><p>Orient Event Service</p><p>WeChat ID: 17321367242</p><p>booking@orient-explorer.com.cn</p><p>Tel: +86 21 51099795</p><p>Make secured online reservation</p><p><a href="https://www.orient-explorer.net/CIFE/"  target="_blank">www.orient-explorer.net/CIFE</a></p><p style="padding-top:10px">LJZ Supreme Tower Hotel</p><p>Tel:(86)13818748050</p><p>+86 21 68986666-3301</p><p>E-mail: kimi.shen@ljzsupremetower.com</p><p>Contact: Kimi</p><p>Intention to Occupy LJZ Supreme Tower Hotel Form: </p><p><a href="https://wj.qq.com/s2/14786136/6loe/"  target="_blank">https://wj.qq.com/s2/14786136/6loe/</a></p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 7A Real-name Authentication Form for Erection Contractor and Transport Contractor',
        url:'./bt/nbt/Form 7A Real-name Authentication Form for Erection Contractor and Transport Contractor.pdf',
        tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888</p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net</p><p>Website: www.sniec.net</p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 7B Letter of Authorization',
        url:'./bt/nbt/Form 7B Letter of Authorization.pdf',
        tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888</p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net</p><p>Website: www.sniec.net</p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 7C Safety Commitment of the Transport Contractor',
        url:'./bt/nbt/Form 7C Safety Commitment of the Transport Contractor.pdf',
        tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888</p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net</p><p>Website: www.sniec.net</p></div>'
      },
      {      
        date: 'July 20, 2024',
        name: 'Form 7D Safety Commitment of the Erection Contractor',
        url:'./bt/nbt/Form 7D Safety Commitment of the Erection Contractor.pdf',
        tip:'<div><p>Shanghai New International Expo Centre Co., Ltd. </p><p>2345 Long yang Road,Shanghai 201204, China </p><p>Tel: (86) 21 2890 6888</p><p>Fax: (86) 21 2890 6866</p><p>Email: info@sniec.net</p><p>Website: www.sniec.net</p></div>'
      }
    ],
    currentData:{},
    dialogVisible:false
  }),
  components: {

  },
  mounted() {
    // this.userInfo.bthType = '标摊'
    if(this.userInfo.bthType == '特装'){
      this.btTable = this.tzBtTableData
      this.nbtTable = this.tzNbtTableData
    }

    if(this.userInfo.bthType == '标摊'){
      this.btTable = this.btBtTableData
      this.nbtTable = this.btNbtTableData
    }
  },
  methods: {
    showDetail(obj){
      this.currentData = obj
      this.dialogVisible = true
      console.log(obj.name)
    }
  }
}
</script>
<style lang="less" scope>
.introduce{
  font-weight: bold;
  font-size: 14px;
}
.introduce p{
  padding:10px 0
}
.downPdf{
  display: flex;
  align-items: flex-end;
  margin: 20px 0;
}
.downPdf .pdfIcon{
  width: 40px;
}
.downPdf .iconDownText{
  margin-left: 10px;
  font-size: 16px;
}
.tableTtiel{
  font-weight: bold;
  font-size: 16px;
}
.tableContent{
  padding: 20px 0;
}
.bottomText{
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
}
.bottomText p{
  padding: 6px;
  // text-align: ;
}
.bottomText span{
  font-size: 20px;
  color: red;
}
.tableBtn{
  font-size: 14px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.dialogContent{
  font-weight: bold;
}
.dialogContent .dialogA{
  font-size: 14px;
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
}
.dialogContent .dialogConct{
     line-height: 26px;
     font-size: 14px;
}
</style>
